import { render, staticRenderFns } from "./KBreadcrumbs.vue?vue&type=template&id=74ccfb80&scoped=true&"
import script from "./KBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./KBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./KBreadcrumbs.vue?vue&type=style&index=0&id=74ccfb80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ccfb80",
  null
  
)

export default component.exports